// The illustrated story — ports app/(privado)/conto/page.tsx.
//
// Two server-side fetches became two queries. They run in parallel, exactly as
// the old Promise.all did.

import { Link } from "react-router";
import { Flourish } from "@/components/ui/Flourish";
import { EntradaConto } from "@/components/conto/EntradaConto";
import { Consulta } from "@/components/ui/EstadoConsulta";
import { useTitle } from "@/components/ui/useTitle";
import { useIllustrations, useMilestoneSummary } from "@/api/queries";

export function Conto() {
  useTitle("O nosso conto");
  const query = useIllustrations();
  const marcos = useMilestoneSummary();

  return (
    <main className="mx-auto max-w-4xl px-6 py-16">
      <header className="text-center">
        <p className="font-display text-lg italic text-ouro-600">Era uma vez…</p>
        <h1 className="mt-2 font-display text-4xl text-tinta">O nosso conto ilustrado</h1>
        <div className="my-6">
          <Flourish />
        </div>
          <Link
            to="/conto/adicionar"
            className="inline-block rounded-full bg-ouro px-6 py-3 text-sm font-semibold text-creme-50 shadow-[0_10px_28px_-10px_rgba(201,162,39,0.65)] transition-all hover:bg-ouro-600 hover:-translate-y-0.5"
          >
            + Nova ilustração
          </Link>
      </header>

      <Consulta query={query}>
        {(ilustracoes) =>
          ilustracoes.length === 0 ? (
            <p className="mx-auto mt-12 max-w-prose text-center leading-relaxed text-tinta-700">
              O nosso conto ainda está em branco. Adiciona a primeira ilustração e a
              sua história ao lado.
            </p>
          ) : (
            <div className="mt-12 flex flex-col gap-16">
              {ilustracoes.map((il, i) => (
                <EntradaConto
                  key={il.id}
                  ilustracao={il}
                  marcos={marcos.data ?? []}
                  indice={i}
                  total={ilustracoes.length}
                />
              ))}
            </div>
          )
        }
      </Consulta>
    </main>
  );
}
